var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8675 1.25751L13.7425 3.13251L12.3131 4.56251L10.4381 2.68751L11.8675 1.25751ZM5 10H6.875L11.4294 5.44563L9.55437 3.57063L5 8.12501V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.875H5.09875C5.0825 11.875 5.06563 11.8813 5.04938 11.8813C5.02875 11.8813 5.00813 11.8756 4.98688 11.875H3.125V3.125H7.40438L8.65438 1.875H3.125C2.43562 1.875 1.875 2.435 1.875 3.125V11.875C1.875 12.565 2.43562 13.125 3.125 13.125H11.875C12.2065 13.125 12.5245 12.9933 12.7589 12.7589C12.9933 12.5245 13.125 12.2065 13.125 11.875V6.4575L11.875 7.7075V11.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEdit);
export default __webpack_public_path__ + "static/media/whiteEdit.5f5d15cf7aacb21cdca1b36e0db9c8bb.svg";
export { ForwardRef as ReactComponent };